import { Pipe, PipeTransform, inject } from '@angular/core';
import { GeoLocation } from '@wilson/interfaces';
import { Observable, of } from 'rxjs';
import { LocationsStoreService } from '../../locations-store.service';

/**
 * Use this pipe on **portal only**.
 * On mobile, use `AioLocationIdToLocationPipe` instead.
 */
@Pipe({
  name: 'locationIdToLocation',
  standalone: true,
})
export class LocationIdToLocationPipe implements PipeTransform {
  private readonly locationStoreService = inject(LocationsStoreService);

  transform(
    id: string | undefined,
  ): Observable<GeoLocation | undefined | null> {
    if (!id) {
      return of(undefined);
    }
    return this.locationStoreService.getLocationFromCache(id);
  }
}
